











































import Component, { mixins } from "vue-class-component";
import AxiosMixin from "@/mixins/axiosMixin";
import { Emit } from "vue-property-decorator";
import LoadingDialog from "../common/LoadingDialog.vue";
import { BeppyoDiseaseCodeMaster } from "@/components/medicalTypes/types";

@Component({
  components: {
    LoadingDialog
  }
})
export default class DiseaseSettingDialog extends mixins(AxiosMixin) {
  private masters: BeppyoDiseaseCodeMaster[] = [];
  private headers = [
    {
      value: "div_name",
      text: "区分",
      width: "10%"
    },
    {
      value: "code",
      text: "コード",
      width: "15%"
    },
    {
      value: "name",
      text: "名称",
      width: "75%"
    }
  ];
  private selectItems: BeppyoDiseaseCodeMaster[] = [];
  private beppyou_codes: string[] = [];
  private isActive = false;

  public open(beppyou_code: string) {
    const beppyou_code_emptyspace = beppyou_code.split(" ");
    this.beppyou_codes = beppyou_code_emptyspace.filter(
      element => element !== ""
    ); //空の文字列の要素を除外する
    this.updateData();
    this.isActive = true;
  }

  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/medical/edit/get_disease_masters",
      {},
      res => {
        this.masters = res.data.masters;
        this.masters = this.masters.filter(s => s.code != "41"); //別表8令和6年6月以降のもの
        this.masters.forEach(item => {
          if (item.code_after_r8 && Number(item.code_after_r8) >= 41) {
            item.code = item.code_after_r8;
          } else if (Number(item.code_after_r6) >= 41) {
            item.code = item.code_after_r6;
          }
        });
        this.selectItems = this.masters.filter(s => {
          if (!s.code_after_r6 && !s.code_after_r8) {
            //別表7
            return this.beppyou_codes.includes(s.code);
          } else {
            //別表8: R8コード優先
            const targetCode = s.code_after_r8 || s.code_after_r6;
            return this.beppyou_codes.includes(targetCode);
          }
        });
        console.log(this.beppyou_codes);
        console.log(this.selectItems);
      }
    );
  }

  private clickSelect() {
    const beppyou_code = this.selectItems
      .map(x => x.code)
      .reduce((acc, x) => (acc += " " + x));
    if (confirm("「" + beppyou_code + "」を反映します。よろしいですか？")) {
      this.select(beppyou_code);
      this.isActive = false;
    }
  }

  private clickCancel() {
    this.isActive = false;
  }

  @Emit()
  select(beppyou_code: string) {
    return beppyou_code;
  }
}
